// Start: [-71.142083, 21.426963]
// Circle center: [-71.0390, 21.3806]
// Entry point: [-71.0516, 21.388798] — the drone arrives here, circles twice, then returns

const START: [number, number] = [-71.142083, 21.426963];
const CIRCLE_CENTER: [number, number] = [-71.039, 21.3806];
const ENTRY_POINT: [number, number] = [-71.0516, 21.388798];

// Compute radius and entry angle from the entry point so circles start/end exactly where the straight path meets the circle
const dx = ENTRY_POINT[0] - CIRCLE_CENTER[0];
const dy = ENTRY_POINT[1] - CIRCLE_CENTER[1];
const RADIUS = Math.sqrt(dx * dx + dy * dy);
const ENTRY_ANGLE = Math.atan2(dy, dx);

function lerp(a: [number, number], b: [number, number], steps: number): [number, number][] {
  const pts: [number, number][] = [];
  for (let i = 0; i <= steps; i++) {
    const t = i / steps;
    pts.push([a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]);
  }
  return pts;
}

function circleFromAngle(
  center: [number, number],
  radius: number,
  startAngle: number,
  count: number,
): [number, number][] {
  const pts: [number, number][] = [];
  for (let i = 0; i <= count; i++) {
    const angle = startAngle + (2 * Math.PI * i) / count;
    pts.push([center[0] + radius * Math.cos(angle), center[1] + radius * Math.sin(angle)]);
  }
  return pts;
}

// Build path: start → entry point, circle 1, circle 2, entry point → start
const toEntry = lerp(START, ENTRY_POINT, 8);
const circle1 = circleFromAngle(CIRCLE_CENTER, RADIUS, ENTRY_ANGLE, 30);
const circle2 = circleFromAngle(CIRCLE_CENTER, RADIUS, ENTRY_ANGLE, 30);
const toStart = lerp(ENTRY_POINT, START, 8);

export const ORIGINAL_COORDS: [number, number][] = [
  ...toEntry, // 9 points, last is ENTRY_POINT
  ...circle1.slice(1), // 30 points (skip first = ENTRY_POINT duplicate)
  ...circle2.slice(1), // 30 points
  ...toStart.slice(1), // 8 points (skip ENTRY_POINT duplicate)
];
